import {fromJS, List as IList, Map as IMap} from 'immutable';
import {createEisTypeObject} from 'Quoting/utils/utilities';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {
  getAmountValuePath,
  getGPLUBenefitScheduleBlockPropertyPaths,
  getParentPath,
} from '../QuoteForm/Plan/products/GWL/PropertyPaths';
import {useQuoteField} from './useHandleQuoteFieldChange';
import { GPLUCoverageCode } from '../QuoteForm/Plan/PlanTemplates/GWL/gpluConstants';

const SPECIFIED_AMOUNTS_ATTRIBUTE_KEY = 'specifiedAmount';

export const useMultipleValues = (entityName: string) => {
  const {getQuoteFieldValue, updateQuoteFieldValues} = useQuoteField();
  const {selectedPlan, selectedCoverageIndex} = useSelector((state: ReducerState) => state.quoteForm);

  const benefitScheduleKey: any = getQuoteFieldValue(
    `${getParentPath(selectedPlan?.planIndex, selectedCoverageIndex)}.benefitSchedule._key`
  );

  const propertyPaths = getGPLUBenefitScheduleBlockPropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex);

  const [rootId, parentId] = [benefitScheduleKey?.get('rootId'), benefitScheduleKey?.get('id')];

  const quoteMultipleValues: IList<IMap<string, any>> = getQuoteFieldValue(propertyPaths.multipleValues);

  const specifiedAmounts: string[] = (quoteMultipleValues || IList())
    .map((m: IMap<string, any>) => String(m.get(SPECIFIED_AMOUNTS_ATTRIBUTE_KEY)))
    .filter(Boolean)
    .toArray();

  const handleSpecifiedAmounts = (newValues: string[], covcode?: GPLUCoverageCode) => {
    const lookup = new Map<string, IMap<string, any>>();
    quoteMultipleValues.forEach(m => {
      lookup.set(String(m.get(SPECIFIED_AMOUNTS_ATTRIBUTE_KEY)), m);
    });

    const updatedMultipleValues = IList(
      newValues?.map(amount => {
        const key = amount;
        return (
          lookup.get(key) ??
          fromJS({
            ...createEisTypeObject(entityName, rootId, parentId),
            specifiedAmount: Number(key),
          })
        );
      })
    );

    updateQuoteFieldValues([
      {path: propertyPaths.multipleValues, newValue: updatedMultipleValues},
      (covcode == GPLUCoverageCode.WHOLE_LIFE) && {
        path: getAmountValuePath(propertyPaths.maxDeathBenefitAmountAllowance),
        newValue: Math.max(...updatedMultipleValues.map(c => c.get(SPECIFIED_AMOUNTS_ATTRIBUTE_KEY))),
      },
      (covcode == GPLUCoverageCode.WHOLE_LIFE) && {
        path: getAmountValuePath(propertyPaths.minDeathBenefitAmountAllowance),
        newValue: Math.min(...updatedMultipleValues.map(c => c.get(SPECIFIED_AMOUNTS_ATTRIBUTE_KEY))),
      },
    ]);
  };

  return {specifiedAmounts, handleSpecifiedAmounts};
};
